export default {"src":"/_next/static/media/icon_x.a1d14553.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};